import { IAppState } from '../../../AppModulesWrapper';

import { ITermsDuration } from '../../types/reducers/termsDurations';

export function selectTermsDurations(state: IAppState): ITermsDuration[] {
  return state.servicePickerWidget.termsDurations.durations;
}
